import { render, staticRenderFns } from "./FacilityEdit.vue?vue&type=template&id=8397a32a&scoped=true"
import script from "./FacilityEdit.vue?vue&type=script&lang=js"
export * from "./FacilityEdit.vue?vue&type=script&lang=js"
import style0 from "./FacilityEdit.vue?vue&type=style&index=0&id=8397a32a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8397a32a",
  null
  
)

export default component.exports